// extracted by mini-css-extract-plugin
export default {"guide":"Guide_guide__b5jAI","directionsIcons":"Guide_directionsIcons__NIz02","companyName":"Guide_companyName__vQqU6"};